import type { AccountingMessages } from "./messages.en";

export const accountingEs: Partial<Record<keyof AccountingMessages, string>> = {
  "accounting.jonasChart.title": "Revisión del catálogo contable de Jonas",
  "accounting.jonasChart.subtitle": "Revise las cuentas de Jonas recibidas, sus correspondencias propuestas y la evidencia de origen. Esta pantalla no cambia datos.",
  "accounting.jonasChart.emptyTitle": "No hay cuentas recibidas",
  "accounting.jonasChart.emptyBody": "No hay cuentas del catálogo contable de Jonas disponibles. Los resúmenes mensuales son distintos y no contienen el detalle de cuentas del libro mayor.",
  "accounting.jonasChart.statusLabel": "Estado de la recepción del catálogo contable",
  "accounting.jonasChart.totalRows": "{total} filas de origen recibidas",
  "accounting.jonasChart.safety": "Revisión de solo lectura. Las correspondencias propuestas provienen de la vista previa actual; aquí no se aplica ningún cambio.",
  "accounting.jonasChart.incomplete": "La recepción o la vista previa está incompleta: hay {actual} filas disponibles; el lote esperaba {expected}. Revise la transferencia de origen y los problemas indicados.",
  "accounting.jonasChart.unknownExpected": "desconocido",
  "accounting.jonasChart.batchComplete": "El total coincide con el lote ({expected})",
  "accounting.jonasChart.sourceAccount": "Cuenta de Jonas",
  "accounting.jonasChart.proposed": "Cuenta nativa propuesta",
  "accounting.jonasChart.nativeMatch": "Correspondencia nativa actual",
  "accounting.jonasChart.flags": "Indicadores de revisión",
  "accounting.jonasChart.evidenceColumn": "Evidencia de origen",
  "accounting.jonasChart.missingNumber": "Falta el número de cuenta",
  "accounting.jonasChart.noDescription": "Sin descripción",
  "accounting.jonasChart.proposedDetails": "{type}; tipo según {basis}; {action}",
  "accounting.jonasChart.type.asset": "Activo",
  "accounting.jonasChart.type.liability": "Pasivo",
  "accounting.jonasChart.type.equity": "Patrimonio",
  "accounting.jonasChart.type.revenue": "Ingresos",
  "accounting.jonasChart.type.expense": "Gastos",
  "accounting.jonasChart.basis.override": "configuración del club",
  "accounting.jonasChart.basis.jonas_type": "tipo de cuenta de Jonas",
  "accounting.jonasChart.basis.number_range": "rango del número de cuenta",
  "accounting.jonasChart.basis.parent": "cuenta principal",
  "accounting.jonasChart.action.create": "crear",
  "accounting.jonasChart.action.match": "vincular",
  "accounting.jonasChart.action.update": "actualizar",
  "accounting.jonasChart.action.unchanged": "sin cambios",
  "accounting.jonasChart.noProposal": "Sin propuesta",
  "accounting.jonasChart.active": "Activa",
  "accounting.jonasChart.inactive": "Inactiva",
  "accounting.jonasChart.noNativeMatch": "Sin correspondencia con una cuenta nativa",
  "accounting.jonasChart.noFlags": "Ninguno",
  "accounting.jonasChart.issueCount": "{count} problemas",
  "accounting.jonasChart.warningCount": "{count} advertencias",
  "accounting.jonasChart.evidence": "{file} · registro {key}",
  "accounting.jonasChart.batch": "Lote",
  "accounting.jonasChart.batchNumber": "Número del lote",
  "accounting.jonasChart.extractId": "ID de extracción",
  "accounting.jonasChart.extractedAt": "Capturado desde Jonas",
  "accounting.jonasChart.notRecorded": "No registrado",
  "accounting.jonasChart.loadedAt": "Recibido por ClubCore",
  "accounting.jonasChart.sourceHash": "Hash del origen",
  "accounting.jonasChart.noProvenance": "No está disponible la procedencia del lote de origen.",
  "accounting.jonasChart.noEvidence": "No hay campos de evidencia de origen disponibles.",
  "accounting.jonasChart.pagination": "Páginas de revisión del catálogo contable de Jonas",
  "accounting.jonasChart.rowRange": "Filas {from}–{to} de {total}",
  "accounting.jonasChart.previous": "Anterior",
  "accounting.jonasChart.next": "Siguiente",

};
